export const AUTOMAP_ADMIN_PORTAL_BASE = "/v/automap/admin";

export function automapAdminPortalPath(segment = "") {
  const normalized = String(segment || "").replace(/^\/+/, "");
  return normalized ? `${AUTOMAP_ADMIN_PORTAL_BASE}/${normalized}` : AUTOMAP_ADMIN_PORTAL_BASE;
}
